import type { ClientPortfolioDetailRelatedResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { PinKind } from "web_myplann/Portfolio/Components/Redesign/Detail/Pin/pinKind";
import { getRelatedPropertyTitle } from "web_myplann/Portfolio/Helpers/getRelatedPropertyTitle";
import { isServiceOrAdvisoryDomain } from "web_myplann/Portfolio/Helpers/isServiceOrAdvisoryDomain";
import { relatedPortfolioLabel } from "web_myplann/Portfolio/Helpers/relatedPortfolioLabel";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const relatedByPinKind = (
	related: ClientPortfolioDetailRelatedResponseDTO[],
	kind: Exclude<PinKind, "document">,
): ClientPortfolioDetailRelatedResponseDTO[] => {
	if (kind === "property") {
		return related.filter((item) => item.relatedProperty);
	}

	const wantsService = kind === "service";

	return related.filter(
		(item) =>
			item.relatedPortfolio &&
			isServiceOrAdvisoryDomain(item.relatedPortfolio.domain) === wantsService,
	);
};

export const relatedTitle = (
	item: ClientPortfolioDetailRelatedResponseDTO,
	kind: Exclude<PinKind, "document">,
	t: TranslateFunction,
): string => {
	if (kind === "property") {
		return item.relatedProperty
			? getRelatedPropertyTitle(item.relatedProperty, t)
			: "";
	}

	return item.relatedPortfolio
		? relatedPortfolioLabel(item.relatedPortfolio, t)
		: "";
};
